import { render, staticRenderFns } from "./ProductInfoImages.vue?vue&type=template&id=4071f01a&scoped=true"
import script from "./ProductInfoImages.vue?vue&type=script&lang=ts"
export * from "./ProductInfoImages.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfoImages.vue?vue&type=style&index=0&id=4071f01a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071f01a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4071f01a')) {
      api.createRecord('4071f01a', component.options)
    } else {
      api.reload('4071f01a', component.options)
    }
    module.hot.accept("./ProductInfoImages.vue?vue&type=template&id=4071f01a&scoped=true", function () {
      api.rerender('4071f01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoImages.vue"
export default component.exports